import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../_services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  // SSR safe — uses AuthService which already handles isPlatformBrowser
  if (!authService.isLoggedIn()) {
    authService.setRedirectUrl(state.url);
    return new RedirectCommand(
      router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } }),
    );
  }

  return true;
};
export const noAuthGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  if (authService.isLoggedIn()) {
    return new RedirectCommand(router.createUrlTree(['/search']), { replaceUrl: true });
  }

  return true;
}
